import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import {
  PagePaginationResponseDtoSchema,
  responseContract,
  type PagePaginationRequestDto,
} from '../../lib';
import { FacilityDtoSchema } from '../contracts';

export enum GetFacilitiesOccupancyEnumDto {
  LT_25 = 'LT_25',
  B25_50 = 'B25_50',
  B50_75 = 'B50_75',
  B75_100 = 'B75_100',
}

export enum GetFacilitiesCreatedAlertsEnumDto {
  GT_50 = 'GT_50',
  B25_50 = 'B25_50',
  LT_25 = 'LT_25',
}

export enum GetFacilitiesCreatedFlagsEnumDto {
  GT_50 = 'GT_50',
  B25_50 = 'B25_50',
  LT_25 = 'LT_25',
}

const GetFacilitiesResponseDtoSchema =
  PagePaginationResponseDtoSchema(FacilityDtoSchema);

export type GetFacilitiesRequestDto = PagePaginationRequestDto<
  {
    from: string;
    to: string;
    occupancy: GetFacilitiesOccupancyEnumDto[] | null;
    createdAlerts: GetFacilitiesCreatedAlertsEnumDto[] | null;
    createdFlags: GetFacilitiesCreatedFlagsEnumDto[] | null;
    includeNullOccupancy?: boolean;
    search?: string | null;
    minAlerts?: number | null;
    maxAlerts?: number | null;
    minFlags?: number | null;
    maxFlags?: number | null;
    /* Financial tab "Revenue" filter, on the period total (ST #137). */
    minRevenue?: number | null;
    maxRevenue?: number | null;
  },
  | 'status'
  | 'name'
  | 'occupancy'
  | 'beds'
  | 'bedsHighest'
  | 'numberOfStaff'
  | 'numberOfResidents'
  | 'staffingRatio'
  | 'monthlyTotalRevenue'
  | 'revenuePerResident'
  | 'revenue'
  | 'expenses'
  | 'margin'
  | 'revenuePerBed'
  | 'payerDistribution'
  | 'payerDistributionRevenue'
  | 'createdFlags'
  | 'createdAlerts'
>;
export type GetFacilitiesResponseDto = z.infer<
  typeof GetFacilitiesResponseDtoSchema
>;

export const getFacilities = (
  params: GetFacilitiesRequestDto,
  config?: AxiosRequestConfig<GetFacilitiesRequestDto>
) => {
  const transformedParams: GetFacilitiesRequestDto = {
    ...params,
    search: params.search?.trim() ? params.search.trim() : null,
  };

  return api
    .get('/facilities', {
      params: transformedParams,
      ...config,
    })
    .then(responseContract(GetFacilitiesResponseDtoSchema));
};
